export class UploadedFiles {
    html: string;
    path: string;
    fileName: string;
    language: string;

    constructor(html: string, path: string, fileName: string, language: string) {
        this.html = html;
        this.path = path;
        this.fileName = fileName;
        this.language = language;
    }
}
